/**
 * @generated SignedSource<<62ded790dd3b1e9df6fe8d250534d55c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DittoPortalProviderQuery$variables = {
  appId: string;
};
export type DittoPortalProviderQuery$data = {
  readonly viewer: {
    readonly appById: {
      readonly cloudUrls: ReadonlyArray<{
        readonly url: string;
      }>;
      readonly createdAt: string;
    } | null;
  };
};
export type DittoPortalProviderQuery = {
  response: DittoPortalProviderQuery$data;
  variables: DittoPortalProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DittoPortalProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppDomainStatus",
                "kind": "LinkedField",
                "name": "cloudUrls",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DittoPortalProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppDomainStatus",
                "kind": "LinkedField",
                "name": "cloudUrls",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e20e4d1b1957b9883a9c4eef607e7884",
    "id": null,
    "metadata": {},
    "name": "DittoPortalProviderQuery",
    "operationKind": "query",
    "text": "query DittoPortalProviderQuery(\n  $appId: ID!\n) {\n  viewer {\n    appById(id: $appId) {\n      cloudUrls {\n        url\n        id\n      }\n      createdAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "391af92c83e3f8b8b8e1d1e9481dd8d5";

export default node;
